<template>
  <div class="sticky bottom-0 bg-white">
    <div class="flex max-h-8 items-center justify-between gap-2 py-1">
      <div class="text-xs">
        <span
          :class="{
            'sm:hidden': !longTextEdited,
          }"
        >
          {{ $t("legal_text.textEditor.status.last_edited") }}
        </span>
        <time>{{ lastEdited }}</time>
      </div>
      <Transition name="fade" mode="out-in">
        <LexmeaSwitch
          v-if="publishable && !editing"
          class="text-xs"
          :modelValue="Boolean(entry.published_at)"
          @update:modelValue="isPublishModalOpen = true"
        >
          <template #before>{{
            $t("legal_text.textEditor.status.hide")
          }}</template>
          <template #after>{{
            $t("legal_text.textEditor.status.publish")
          }}</template>
        </LexmeaSwitch>
        <AutosaveStatus
          v-else-if="editing"
          class="max-lg:mr-4"
          :longText="longTextEdited"
        />
      </Transition>
    </div>
    <PublishSchemaModal
      v-if="publishable"
      v-model="isPublishModalOpen"
      :schema="entry"
      :loading="saving"
      @publish="onPublishAction"
    />
  </div>
</template>

<script setup lang="ts">
import type { ISchema } from "~/models/IUserEntry";

interface Props {
  editing: boolean;
  entry: ISchema;
  publishable: boolean;
  saving: boolean;
}

type Emits = {
  publish: [value: boolean];
};

const props = defineProps<Props>();

const emit = defineEmits<Emits>();

const { inverseAbsoluteSize } = useSplitpane();

const isPublishModalOpen = ref(false);

const onPublishAction = (publish: boolean) => {
  isPublishModalOpen.value = false;
  emit("publish", publish);
};

const lastEdited = useDateFormat(() => props.entry.updated_at, "DD.MM.YYYY");

// easiest way, but not the best - 530 is just a guess
const longTextEdited = computed(() => inverseAbsoluteSize.value > 540);
</script>
